import { z } from "zod";

import { BRAND_MARKUP } from "../../constants";
import { attachment } from "../shared";
import { defineModel } from "../types";

// Same pricing as STT (duration-based)
const COST_PER_SECOND_MICRODOLLARS = (0.4 / 3600) * 1_000_000;

const elevenlabsExtractTimestampsParams = z
  .object({
    text: z.string().default(""),
    attachments: z.array(attachment).optional(),
  })
  .strip();

export const elevenlabsExtractTimestamps = defineModel({
  key: "elevenlabs-extract-timestamps",
  stepType: "alignment",
  spec: {
    label: "ElevenLabs",
    description:
      "Extract word-level timestamps from audio and text using forced alignment",
    icon: "elevenlabs-icon.svg",
    tags: ["elevenlabs"],
    features: { attachments: true, prompts: true } as const,
    options: {
      attachments: [
        {
          type: "audio",
          label: "Audio File",
          slot: "audio",
          required: true,
          allowedFormats: ["audio/wav", "audio/mp3", "audio/mpeg", "audio/m4a"],
        },
      ],
    },
    params: elevenlabsExtractTimestampsParams,
  },
  providers: [
    {
      provider: "elevenlabs",
      modelId: "elevenlabs-extract-timestamps",
      estimateCost(_params) {
        // Default estimate for 60 seconds of audio
        const estimatedDurationSeconds = 60;
        return Math.round(
          estimatedDurationSeconds *
            COST_PER_SECOND_MICRODOLLARS *
            (1 + BRAND_MARKUP),
        );
      },
      toPayload(params) {
        // Text can come from params.text (manual entry) or prompt (connected node)
        const text = (
          params.text ||
          (params as { prompt?: string }).prompt ||
          ""
        ).trim();
        if (!text) {
          throw new Error(
            "elevenlabs-extract-timestamps requires non-empty text. Set params.text or connect a prompt-producing node upstream.",
          );
        }
        return { text };
      },
    },
  ],
});
